<template>
	<Card>
		<template #content>
		<FormGroup label="Release Notes">
			<div class="rounded-md border border-surface-300 bg-surface-0 dark:bg-surface-800 dark:border-surface-700">
				<ul role="list" class="divide-y divide-surface-300 dark:divide-surface-700">
					<li v-for="(item, index) in selectedFirmware.release_notes" :key="item.id"
					    class="px-4 py-4 flex space-x-2 items-center">
						<FileTypeIcon :mime-type="item.mime_type"/>
						<div class="flex-1">
							<h3 class="flex-auto truncate text-sm font-medium leading-4 text-surface-900 dark:text-surface-200">{{ item.name }}</h3>
							<p class="block text-sm text-surface-600 dark:text-surface-400">{{ useFilesize(item.size_bytes) }}</p>
						</div>

						<Button
								type="button"
								@click="toggle($event, index)"
								severity="secondary"
								size="small"
								text
								aria-haspopup="true"
								aria-controls="overlay_menu"
						>
							<template #icon>
								<IconDots/>
							</template>
						</Button>
						<Menu ref="menu" id="overlay_menu" :model="[
										{ label: $t('forms.common.download'), icon: 'FileTypeIcon', command: (e) => { this.$emit('on-download', item)} },
										{ label: $t('forms.common.delete'), icon: 'IconTrash', command: (e) => onDelete(item) },
								]" :popup="true">
							<template #itemicon="{ item, class: classes }">
								<component v-if="item.icon" :is="item.icon" :classes="classes" class="mr-2" :mime-type="selectedFirmware.mime_type"/>
							</template>
						</Menu>
					</li>
				</ul>
			</div>
		</FormGroup>
		</template>
	</Card>
</template>

<script>
import { IconDots, IconFileCode, IconFileTypePdf, IconTrash } from '@tabler/icons-vue';
import FileInput from "@/Components/FileInput.vue";
import FormGroup from "@/Components/FormGroup.vue";
import { useFilesize } from "@/Composables/Filesize.js";
import FileTypeIcon from "@/Components/FileTypeIcon.vue";

export default {
	name: "FirmwareReleaseNotesList",
	methods: {
		useFilesize,
		onDelete(item) {
			this.$confirm.require({
				group: 'delete',
				header: this.$t('forms.firmware.firmware_release_notes_list.delete_release_note'),
				message: this.$t('forms.firmware.firmware_release_notes_list.are_you_sure_you_want_to_delete_this_release_note'),
				accept: () => {
					this.$emit('on-delete', item);
				},
				reject: () => {
					this.$toast.add({
            severity: 'info',
            summary: this.$t('forms.common.cancelled'),
            detail: this.$t('forms.firmware.firmware_release_notes_list.release_note_was_not_deleted'),
            life: 3000
          });
				}
			});
		},
		toggle(e, index){
			this.$refs.menu[index].toggle(e);
		}
	},
	emits: ['on-delete', 'on-download'],
	components: {
		IconDots,
		FileTypeIcon,
		FormGroup, FileInput, IconFileCode, IconFileTypePdf, IconTrash
	},
	props: {
		selectedFirmware: {
			type: Object,
			required: true,
		},
	},
}
</script>

<style scoped>

</style>